import { type RequestStatus } from "./types";

export function StoreLoader(props: { statuses: RequestStatus[]; loader: React.ReactNode; children: React.ReactNode }) {
  const isLoading = props.statuses.every((status) => status === "loading");

  if (isLoading) {
    return props.loader;
  }
  return props.children;
}
